import { createSelector } from "reselect";

import {
  selectCartContainsSurcharge,
  selectCartContainsTariffSurcharge,
  selectCartProductAmount,
  selectCartSurcharge,
  selectTotalCartPrice,
  selectTotalCartPriceWithoutDiscount,
  selectTotalCartWeight,
  selectTotalItemCount,
} from "~/features/cart/cart/redux/selectors/cartSelectors";
import {
  selectAccountNumber,
  selectCartContainsHousingKIT,
  selectIsRequestInFlight,
} from "~/features/cart/cart/redux/selectors/cartPageSelectors";

export const selectCartPageAggregates = (campaignDiscountEnabled: boolean) =>
  createSelector(
    selectTotalCartWeight,
    selectTotalCartPrice,
    selectTotalCartPriceWithoutDiscount(campaignDiscountEnabled),
    selectCartContainsSurcharge,
    selectCartContainsTariffSurcharge,
    selectCartSurcharge,
    selectCartContainsHousingKIT,
    selectTotalItemCount,
    selectCartProductAmount,
    selectAccountNumber,
    selectIsRequestInFlight,
    (
      totalWeight,
      totalSum,
      totalDiscount,
      hasAnySurcharge,
      hasAnyTariffSurcharge,
      surchargeValue,
      containsHousingKits,
      totalItemCount,
      productAmount,
      accountNumber,
      requestInFlight,
    ) => ({
      totalWeight,
      totalSum,
      totalDiscount,
      hasAnySurcharge,
      hasAnyTariffSurcharge,
      surchargeValue,
      containsHousingKits,
      totalItemCount,
      productAmount,
      accountNumber,
      requestInFlight,
    }),
  );

export type CartPageAggregates = ReturnType<ReturnType<typeof selectCartPageAggregates>>;
